import boletos from './Paginas/lista_boletos';
import home from './Paginas/home';
import boleto from './Paginas/boleto';
import theme from './Styles/mainTheme'
import './App.css';
import React from 'react'
import ContextProvider from './Context'
import Aviso from './Components/Aviso';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/core'

function App() {
  return (
    <ContextProvider>
    <BrowserRouter basename={'/bl'}>
      <div className="App">
        <ThemeProvider theme={theme} >
          <Aviso/>
          <Switch>
              <Route path='/lista_boletos' component={boletos}/>
              <Route path='/boleto*' component={boleto}/>
              <Route path='/*' component={home}/>
          </Switch>
          </ThemeProvider>
      </div>
    </BrowserRouter>
    </ContextProvider>
  );
}

export default App;
